import React, { useState } from "react";

const State = () => {

    // const state = useState();

    const [count, setCount] = useState(0);

    const IncNum = () => {
        setCount (count + 1);
    }
    return(
        <>
            <h1>{count}</h1>
            <button onClick={IncNum} className="btn btn-primary"> Click Me</button>
        </>
    )
}

export default State;